export default __webpack_public_path__ + "static/media/icon-user.030898ef.svg";